"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FreshlyRoastedPerfection() {
  return <section data-section-id="221680" id="zero-deviation-welcome" className="relative min-h-screen w-full overflow-hidden bg-background flex flex-col justify-center pt-20 pb-12 dark">
      {}
      <div className="absolute top-1/4 -left-20 w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] bg-chart-1/10 rounded-md blur-[120px] pointer-events-none -z-10" />
      <div className="absolute bottom-0 right-0 w-[40vw] h-[40vw] max-w-[600px] max-h-[600px] bg-secondary/5 rounded-md blur-[100px] pointer-events-none -z-10" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 flex-grow flex flex-col lg:flex-row items-center gap-12 lg:gap-8">
        
        {}
        <div className="w-full flex flex-col items-start justify-center relative pt-12 lg:pt-0">
          
          {}
          
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680334/img/medical_precision_element_2.png" alt="Precision Element" className="absolute top-1/2 -right-4 lg:right-12 w-24 h-24 object-contain opacity-30 animate-[bounce_5s_ease-in-out_infinite_reverse]" aria-hidden="true" />
          

          <h1 className="text-6xl sm:text-7xl lg:text-[5rem] xl:text-[5.5rem] leading-[1.05] font-default font-bold text-foreground tracking-tighter mb-6 relative z-10">
            Welcome to LuminAid, <br />
            <span className="text-chart-1 italic relative inline-block">
              Zero Deviation.
              {}
              <span className="absolute -bottom-2 left-0 w-full h-3 bg-chart-1/20 -z-10 rounded-md" />
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl text-muted-foreground max-w-xl mb-10 leading-relaxed font-default">
            Total Delivery. Guaranteed Quality. Our precision-engineered supply chain ensures your medical facility never faces a shortage of critical consumables.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link to="/RegistrationPage">
              <Button size="lg" className="bg-chart-1 text-primary-foreground hover:bg-chart-1/90 text-lg h-14 px-8 rounded-md shadow-lg shadow-chart-1/25 transition-transform hover:scale-105 font-default font-semibold">
                Register for Access
              </Button>
            </Link>
            <Link to="/OurStandardsPage">
              <Button variant="ghost" size="lg" className="text-foreground hover:bg-accent hover:text-accent-foreground text-lg h-14 px-8 rounded-md font-default">
                Our Standards
              </Button>
            </Link>
          </div>
          <p className="mt-4 text-xs font-mono text-muted-foreground uppercase tracking-widest">
            Professional account required for inventory access.
          </p>
        </div>

      </div>

      {}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center text-muted-foreground animate-bounce">
        <span className="text-xs font-mono font-semibold uppercase tracking-widest mb-2 opacity-70">System Check</span>
        <ChevronDown className="w-5 h-5 opacity-70" />
      </div>
    </section>;
}